(function () {
    'use strict';

    angular
        .module('blocks.directives')
        .directive('spCheckboxList', spCheckboxList);

    spCheckboxList.$inject = ['opsIncludeVersion'];
    /* @ngInject */
    function spCheckboxList(opsIncludeVersion) {
        var directive = {
            restrict: 'E',
            link: link,
            scope: {
                'label': '@',
                'listData': '=',
                'selectedArray': '=',
                'allowSelectAll': '@',
                'disabled': '=',
                'helpTextField': '@',
                'dynamicLabel': '=',
                'toggleFn': '&'
            },
            templateUrl: 'app/blocks/directives/_checkboxList.html?v=' + opsIncludeVersion
        };

        return directive;

        function link(scope, element, attrs) {
            scope.filterString = "";
            scope.filterShowing = false;
            scope.filterClick = function () {
                scope.filterShowing = !scope.filterShowing;
                if (!scope.filterShowing) {
                    scope.filterString = "";
                }
            }

            scope.toggleSelection = function (itemId, selectedArray) {
                var wasSelected = false;
                for (var i = 0; i < selectedArray.length; i++) {
                    if (selectedArray[i] == itemId) {
                        selectedArray.splice(i, 1);
                        wasSelected = true;
                        break;
                    }
                }

                if (!wasSelected) {
                    selectedArray.push(itemId);
                }
                if (scope.toggleFn) {
                    scope.toggleFn();
                }
            }

            scope.showFilter = function () {

            }

            var allSelected = false;
            scope.isSelected = function (itemId, selectedArray) {
                if (!selectedArray) {
                    return false;
                }
                for (var i = 0; i < selectedArray.length; i++) {
                    if (selectedArray[i] == itemId) {
                        return true;
                    }
                }
                return false;
            }

            scope.toggleAll = function (selectedArrary) {
                if (!scope.disabled) {
                    if (allSelected) {
                        selectedArrary.length = 0;
                        allSelected = false;
                        if (scope.toggleFn) {
                            scope.toggleFn();
                        }
                        return;
                    }
                    else {
                        allSelected = true;
                    }
                    for (var i = 0; i < scope.listData.length; i++) {
                        var id = scope.listData[i].ID;
                        if (selectedArrary.indexOf(id) == -1) {
                            selectedArrary.push(id);
                        }
                    }
                    if (scope.toggleFn) {
                        scope.toggleFn();
                    }
                }
            }

        }

    }
})();
